import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Empty, Pagination } from "antd";
import PropTypes from "prop-types";

const DataTable = ({ dataSource, columns, pagination, onChange }) => {
  if (dataSource.length && columns.length) {
    return (
      <div>
        <div className="my-4" style={{ overflowX: "auto" }}>
          <Table>
            <Thead>
              <Tr>
                {columns?.map((col) => {
                  return (
                    <Th
                      className={`px-2 text-md-${col.align}`}
                      style={{
                        minWidth: col?.width ? col.width : "",
                        maxWidth: col?.width ? col.width : "",
                      }}
                      key={col.title}
                    >
                      <span>{col.title}</span>
                    </Th>
                  );
                })}
              </Tr>
            </Thead>

            <Tbody>
              {dataSource?.map((row, index) => (
                <Tr key={index}>
                  {columns.map((col, colIndex) => (
                    <Td
                      style={{
                        textAlign: col?.align ? col.align : "inherit",
                        "--width": col?.width ? col.width : "",
                      }}
                      key={colIndex}
                      className="px-2 py-3"
                    >
                      <div className="tableData">
                        {typeof col?.render === "function"
                          ? col?.render(col?.dataIndex ? row[col.dataIndex] : row, row, index)
                          : row[col.dataIndex]}
                      </div>
                    </Td>
                  ))}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>
        {dataSource.length <= 0 ? (
          <Empty className="w-100" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <div className="d-flex">
            <div className="ms-auto">
              <Pagination
                // hideOnSinglePage={true}
                showLessItems={true}
                showQuickJumper
                {...pagination}
                onChange={(page, pageSize) => onChange({ current: page, pageSize })}
              />
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return <Empty className="w-100" image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }
};

export default React.memo(DataTable);

DataTable.propTypes = {
  dataSource: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  pagination: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
